import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthService } from 'src/app/models/auth/_services/auth.service';
import { UserModel } from 'src/app/models/auth/_models/user.model';
import { MicroApplication } from 'src/app/services/microapplications/_models/microapplication.model';
import { MicroapplicationService } from 'src/app/services/microapplications/_services/microapplication.service';
import { Router } from '@angular/router';
import { MenuGroupItem } from 'src/app/models/menu.model';

@Component({
  selector: 'app-widget-visualizer',
  templateUrl: './widget-visualizer.component.html',
  styleUrls: ['./widget-visualizer.component.scss']
})
export class WidgetVisualizerComponent implements OnInit {
  public sessionData = JSON.parse(sessionStorage.getItem('sessionData') || '{}');
  @Input() widget:MicroApplication;
  url: BehaviorSubject<SafeResourceUrl> = new BehaviorSubject<SafeResourceUrl>('');
  urlObserver$: Observable<SafeResourceUrl>;
  private unsubscribe: Subscription[] = [];
  style:string;
  user$: Observable<UserModel>;
  conpany: string;
  codEmpresa: any;
  constructor(private sanitizer: DomSanitizer,
    private auth: AuthService,    public microApps: MicroapplicationService,    private router: Router,) {

      this.urlObserver$ = this.url.asObservable();
     
     }

     ngOnInit(): void {
      sessionStorage.removeItem('Pages');
this.sessionData.remo
      this.codEmpresa = this.sessionData.selectedCompany.code;
      const sub =   this.microApps.GetAllwidget(this.codEmpresa);
        this.unsubscribe.push(sub);
    
      }
    
    
      onRowDblClick(e: any) {
        this.editMicroApp(e.data.emp_codi,e.data.wid_cont);
      }
      gridHeight = () => {
        return Math.round(window.innerHeight / 1.3);
      };
     
    
      editMicroAppclick = (e: any) => {
        this.editMicroApp(e.row.data.emp_codi,e.row.data.wid_cont);
      };
    
      editMicroApp(id: any,cont :any) {
        this.router.navigate(["widgetconfigcomponent"], {
          queryParams: {
            pId: id,
            wId:cont
          },
        });
      }
    
      itemClickToolbar(item: MenuGroupItem) {
        if (!item) {
          return;
        }
        switch (item.name) {
          case "new":
            this.addMicroApp();
            break;
        }
      }
      addMicroApp() {
        this.router.navigate(["components/widgetconfigcomponent"], {});
      }
    ngOnDestroy(): void {
      //Called once, before the instance is destroyed.
      //Add 'implements OnDestroy' to the class.
    
      this.unsubscribe.forEach(sub => {
        sub.unsubscribe();
      });
      
    }
    
    }
    